import { NgModule } from '@angular/core';
import { ApiClient } from './api-client.service';

@NgModule({
  declarations: [],
  imports: [],
  exports: [],
  providers: [ApiClient],
})
export class CommonServicesModule {}
